// Copied from AssetModal/Header/components/AssetModalHeaderTitle.tsx
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { centralizedDisplayTitleSelector } from '~/store/centralizedClip/selectors';

export const AssetTitle = memo(() => {
  const title = useSelector(centralizedDisplayTitleSelector);

  return <div className="w-full truncate font-semibold ads:text-primary text-16 text-gray-12">{title}</div>;
});

AssetTitle.displayName = 'AssetTitle';
